<template>
  <input
    :id="makeKeyId(rowUuid, node.uuid || '')"
    type="number"
    :value="value"
    @input="handleInput"
    @click.stop
    @blur="$emit('blur', $event)"
  />
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import InputBase from "@/components/data/connections/manualSource/inputs/InputBase.vue";

@Component({
  components: {},
})
export default class NumberInput extends InputBase {}
</script>
